'use strict';

var Traceroute = require('actionGroups/traceroute/Traceroute');

module.exports = {
  Model: Traceroute,
};
